import React from 'react'

import { Button, SxProps, Theme } from '@mui/material'
import { countWords } from 'utils/countWords'

import { styles } from './TopicRefinementButton.styles'

export const TEST_ID = 'TopicRefinementButton'

export interface TopicRefinementButtonProps {
	dataTestId?: string
	onClick?: () => void
	promptText: string
	sx?: SxProps<Theme>
}

export const TopicRefinementButton: React.FC<TopicRefinementButtonProps> = ({
	promptText,
	onClick,
	sx,
	dataTestId = 'topic-refinement-button',
}) => {
	const wordCount = countWords(promptText)
	const isEnabled = wordCount >= 3
	const GenAIIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="19"
			height="19"
			viewBox="0 0 19 19"
			fill="currentColor"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.3382 0.855577C13.5869 -0.280424 15.2051 -0.287218 15.4646 0.847424L15.4755 0.90042L15.4999 1.00641C15.7989 2.27558 16.8261 3.24444 18.1114 3.46865C19.2962 3.6752 19.2962 5.37648 18.1114 5.58303C17.4793 5.69305 16.8939 5.98739 16.4285 6.42909C15.9632 6.87078 15.6387 7.44014 15.4959 8.06565L15.4633 8.20426C15.2051 9.3389 13.5882 9.33211 13.3382 8.19611L13.3124 8.07653C13.1752 7.44855 12.8541 6.87569 12.3899 6.43108C11.9257 5.98647 11.3396 5.69028 10.7064 5.58031C9.5243 5.37512 9.5243 3.67656 10.7064 3.47137C11.3373 3.36186 11.9216 3.06745 12.3851 2.62548C12.8485 2.1835 13.1703 1.61385 13.3097 0.988745L13.3287 0.899061L13.3382 0.855577ZM14.326 10.5279C13.6786 10.5153 13.0598 10.2585 12.5936 9.80906C12.4912 9.87664 12.4019 9.96228 12.3301 10.0618C11.7186 10.8717 11.0026 11.6992 10.1928 12.5077C9.57865 13.1219 8.95636 13.6804 8.34222 14.1791C7.72808 13.6804 7.10579 13.1219 6.49164 12.5077C5.90317 11.9204 5.34536 11.3031 4.82042 10.6583C5.31907 10.0428 5.87886 9.42179 6.49164 8.80759C7.25677 8.03971 8.07394 7.32552 8.93734 6.67011C9.0275 6.60552 9.10645 6.52656 9.17104 6.43639C8.91274 6.20086 8.70582 5.91457 8.56321 5.59542C8.4206 5.27626 8.34537 4.93111 8.34222 4.58155C7.00932 3.64802 5.69136 2.95637 4.51471 2.59627C3.24023 2.20628 1.74564 2.10165 0.766009 3.08002C0.131488 3.71596 -0.0410693 4.58019 0.00784452 5.4023C0.0567584 6.22577 0.332578 7.13076 0.749704 8.04935C1.17522 8.96336 1.68322 9.83665 2.26739 10.6583C1.68336 11.4792 1.17537 12.3516 0.749704 13.2646C0.332578 14.1832 0.0567584 15.0882 0.00784452 15.9117C-0.0410693 16.7338 0.130129 17.598 0.766009 18.234C1.40189 18.8685 2.26603 19.0411 3.08806 18.9922C3.91008 18.9419 4.81635 18.6674 5.73484 18.2503C6.56366 17.8739 7.44547 17.3602 8.34358 16.7324C9.24033 17.3602 10.1208 17.8739 10.951 18.2503C11.8681 18.6674 12.7744 18.9433 13.5977 18.9922C14.4198 19.0411 15.2825 18.8685 15.9184 18.2326C16.8981 17.2542 16.7934 15.7595 16.4035 14.4849C16.0312 13.2701 15.307 11.9044 14.326 10.5279ZM3.91823 4.54486C4.70086 4.78402 5.63429 5.23788 6.64518 5.89557C5.5415 6.83206 4.51632 7.85734 3.57991 8.96114C3.21193 8.40075 2.88586 7.81394 2.60435 7.2055C2.24701 6.41737 2.07174 5.76512 2.04184 5.28C2.01331 4.79218 2.13288 4.5965 2.20761 4.52176C2.32989 4.39947 2.78099 4.19836 3.91823 4.54486ZM2.60435 14.1098C2.85436 13.5595 3.18181 12.9684 3.57991 12.3542C4.51677 13.458 5.54241 14.4833 6.64654 15.4198C6.08668 15.7882 5.50038 16.1147 4.89243 16.3968C4.10438 16.7542 3.45219 16.9295 2.96713 16.9594C2.47799 16.9879 2.2837 16.8683 2.20897 16.7936C2.13424 16.7188 2.01467 16.5218 2.0432 16.0353C2.0731 15.5502 2.24701 14.898 2.60571 14.1098H2.60435ZM11.7934 16.3968C11.1857 16.1151 10.5998 15.7885 10.0406 15.4198C11.1434 14.4832 12.1676 13.4579 13.1032 12.3542C13.7594 13.3665 14.2132 14.3001 14.4524 15.0828C14.8002 16.2188 14.5991 16.6713 14.4768 16.7936C14.4007 16.8683 14.2051 16.9879 13.7187 16.958C13.2322 16.9308 12.5814 16.7542 11.7934 16.3968ZM6.9835 10.6583C6.9835 10.298 7.12665 9.95233 7.38146 9.69749C7.63627 9.44266 7.98186 9.29949 8.34222 9.29949C8.70257 9.29949 9.04817 9.44266 9.30298 9.69749C9.55779 9.95233 9.70094 10.298 9.70094 10.6583C9.70094 11.0187 9.55779 11.3644 9.30298 11.6192C9.04817 11.874 8.70257 12.0172 8.34222 12.0172C7.98186 12.0172 7.63627 11.874 7.38146 11.6192C7.12665 11.3644 6.9835 11.0187 6.9835 10.6583Z"
				fill="currentColor"
			/>
		</svg>
	)
	return (
		<Button
			variant="text"
			startIcon={GenAIIcon}
			disabled={!isEnabled}
			onClick={onClick}
			sx={styles({ enabled: isEnabled, sx })}
			data-testid={dataTestId}
			data-node-id="15700:153816"
			aria-pressed={isEnabled}
		>
			AI topic refinement suggestions
		</Button>
	)
}

export default TopicRefinementButton
